"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onProgress = exports.ThreeBase = void 0;
var _three = require("three");
var _tween = _interopRequireDefault(require("@tweenjs/tween.js"));
var _pointerEvent = require("../CommonUtils/pointerEvent");
var _VisualizationInterface = require("../VisualizationInterface");
var _Constants = require("../Constants");
var _removeObject = require("../Utils/removeObject");
var _disposeMaterial = require("../Utils/disposeMaterial");
var _createCanvas = require("../Utils/createCanvas");
var _Deferred = _interopRequireDefault(require("../CommonUtils/Deferred"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// default progress handler
var onProgress = exports.onProgress = function onProgress(xhr) {
  if (xhr.lengthComputable) {
    var percentComplete = xhr.loaded / xhr.total * 100;
    // eslint-disable-next-line no-console
    console.log(percentComplete.toFixed(2) + "% downloaded");
  }
};

/**
 * This object is an additional layer between the Three.js library and this app.
 * Responsibilities:
 *  - handles everything we need to load and render the 3D visualization
 *  - customizes and simplifies the usage of Three.js in this app
 *  - provides functionality for the common 3D tasks (like drawing on a texture)
 */
var ThreeBase = exports.ThreeBase = /*#__PURE__*/function (_VisualizationInterfa) {
  _inherits(ThreeBase, _VisualizationInterfa);
  var _super = _createSuper(ThreeBase);
  function ThreeBase() {
    var _this2;
    _classCallCheck(this, ThreeBase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "_container", null);
    _defineProperty(_assertThisInitialized(_this2), "_customizableMaterialKeys", []);
    _defineProperty(_assertThisInitialized(_this2), "_customizableMaterials", []);
    _defineProperty(_assertThisInitialized(_this2), "_animationFrame", null);
    _defineProperty(_assertThisInitialized(_this2), "_cameraMovementLocked", false);
    _defineProperty(_assertThisInitialized(_this2), "_hitTestEnabled", true);
    _defineProperty(_assertThisInitialized(_this2), "_isAnimating", false);
    _defineProperty(_assertThisInitialized(_this2), "_animationGroups", []);
    _defineProperty(_assertThisInitialized(_this2), "_loadingManager", Object.assign(new _three.LoadingManager(), {
      onError: function onError(url) {
        return _this2.onLoadError(url);
      }
    }));
    _defineProperty(_assertThisInitialized(_this2), "camera", null);
    _defineProperty(_assertThisInitialized(_this2), "scene", null);
    _defineProperty(_assertThisInitialized(_this2), "cameraTweenGroup", new _tween["default"].Group());
    _defineProperty(_assertThisInitialized(_this2), "cameraViews", {});
    /**
     * Starts the continuous animation in the animation frame
     * It also updates the related tween group.
     * @param {number} time The timestamp value from the requestAnimationFrame callback (DOMHighResTimeStamp)
     */
    _defineProperty(_assertThisInitialized(_this2), "animate", function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!_this2._isAnimating) {
        window.cancelAnimationFrame(_this2._animationFrame);
        _this2._animationFrame = null;
        return;
      }
      _this2._animationFrame = window.requestAnimationFrame(_this2.animate);
      if (time) {
        _this2.cameraTweenGroup.update(time);
        if (_this2.controls) {
          _this2.controls.update();
        }
        _this2.render();
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "startAnimation", function (name) {
      if (_this2._animationGroups.indexOf(name) === -1) {
        _this2._animationGroups.push(name);
      }
      if (!_this2._isAnimating) {
        _this2._animationDeferred = new _Deferred["default"]("animation");
        _this2._isAnimating = true;
        _this2.animate();
      }
    });
    /**
     * Stops the currently running animation
     */
    _defineProperty(_assertThisInitialized(_this2), "stopAnimation", function (name) {
      var animGroupIdx = _this2._animationGroups.indexOf(name);
      if (!name) {
        _this2._animationGroups.length = 0;
      } else if (animGroupIdx !== -1) {
        _this2._animationGroups.splice(animGroupIdx, 1);
      }
      if (_this2._animationGroups.length) {
        // there are still running animations in the list
        return;
      }
      window.cancelAnimationFrame(_this2._animationFrame);
      _this2._isAnimating = false;
      if (_this2._animationDeferred) {
        _this2._animationDeferred.resolve();
        delete _this2._animationDeferred;
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "animationRunning", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = _this2._animationDeferred;
            if (!_context.t0) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return _this2._animationDeferred.promise;
          case 4:
            _context.t0 = _context.sent;
          case 5:
            return _context.abrupt("return", _context.t0);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this2), "endAnimation", function () {
      return _this2.cameraTweenGroup.getAll().forEach(function (item) {
        return item.end();
      });
    });
    /**
     * Checks if the pointer intersects with the model
     * @param {MouseEvent|TouchEvent} pointerEvent
     * @returns {{target: { distance, point, face, faceIndex, object }, getTextureHit: (function())}|null}
     */
    _defineProperty(_assertThisInitialized(_this2), "getIntersection", function (pointerEvent) {
      var _this2$_intersectionR;
      var raycaster = new _three.Raycaster();
      var _this2$renderer$domEl = _this2.renderer.domElement.getBoundingClientRect(),
        elementWidth = _this2$renderer$domEl.width,
        elementHeight = _this2$renderer$domEl.height,
        offsetX = _this2$renderer$domEl.left,
        offsetY = _this2$renderer$domEl.top;
      var point = (0, _pointerEvent.getPointFromPointerEvent)(pointerEvent);
      var mouse = new _three.Vector2((point.x - offsetX) / elementWidth * 2 - 1, -((point.y - offsetY) / elementHeight) * 2 + 1);
      raycaster.setFromCamera(mouse, _this2.camera);
      var intersects = raycaster.intersectObjects(((_this2$_intersectionR = _this2._intersectionRoot) === null || _this2$_intersectionR === void 0 ? void 0 : _this2$_intersectionR.children) || _this2.scene.children, true);
      if (intersects.length > 0) {
        var intersect = intersects[0]; // closest object
        return {
          target: intersect,
          getTextureHit: function getTextureHit() {
            var material = intersect.object.material;
            if (material && _this2._customizableMaterialKeys.indexOf(material.name) !== -1) {
              // note: the texture Y is flipped by default in the webgl context
              // see (https://github.com/mrdoob/three.js/issues/5644)
              // so if it's flipped we need to flip it back to get the image coordinates
              var texture = material.map;
              var flipY = texture.flipY;
              var _texture$image = texture.image,
                width = _texture$image.width,
                height = _texture$image.height;
              var x = Math.round(intersect.uv.x * width);
              var y = Math.round((flipY ? 1 - intersect.uv.y : intersect.uv.y) * height);
              return _this2.textureHitFormatter(intersect, {
                width: width,
                height: height,
                x: x,
                y: y
              });
            }
          }
        };
      }
      return null;
    });
    return _this2;
  }
  _createClass(ThreeBase, [{
    key: "init",
    value:
    /**
     * Initializes the 3D renderer, camera and scene
     * @param {HTMLElement} [container=<div>]
     * @param {boolean} useDefaultSetup
     */
    function init() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement("div");
      var useDefaultSetup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this._isInitialized = true;
      var scene = this.createScene();
      this.scene = scene;
      this.camera = this.createCamera();
      scene.add(this.camera);
      this.renderer = this.createRenderer();
      this.addToContainer(container);
      this.setupContextLostHandling();
      if (useDefaultSetup) {
        this.setupDefaultLightning();
        this.setupDefaultControls();
        this.setupDefaultHitTest();
      }
      this.observable.dispatch(_Constants.EventTypes.Initialized);
    }
  }, {
    key: "createScene",
    value: function createScene() {
      return new _three.Scene();
    }

    /**
     * Create and return a customized three.js renderer object
     * @return {WebGLRenderer}
     */
  }, {
    key: "createRenderer",
    value: function createRenderer() {}

    /**
     * Create and return a customized three.js camera object
     * @return {Camera}
     */
  }, {
    key: "createCamera",
    value: function createCamera() {}

    /**
     * Updates the camera size (different setup for different camera types)
     * @param {number} width
     * @param {number} height
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "updateCamera",
    value: function updateCamera(width, height) {}
  }, {
    key: "addToContainer",
    value: function addToContainer(container) {
      this._container = container;
      container.appendChild(this.renderer.domElement);
      var size = container.getBoundingClientRect();
      this.setSize(size, false);
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this._container;
    }

    /**
     * Creates the paths for loading a model (object + material)
     * @returns {{objPath: string, mtlPath: string}}
     */
  }, {
    key: "getModelPaths",
    value: function getModelPaths() {
      var _basePath = this._basePath,
        _itemPath = this._itemPath,
        _materialVariantPath = this._materialVariantPath;
      var objPath = _itemPath ? [_basePath, _itemPath].join("/") : "";
      var mtlPath = _materialVariantPath ? [objPath, "materials", _materialVariantPath].join("/") : "";
      return {
        objPath: objPath,
        mtlPath: mtlPath
      };
    }

    /**
     * Sets the canvas size
     * @param {number} width
     * @param {number} height
     * @param {boolean} rerender
     */
  }, {
    key: "setSize",
    value: function setSize(_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      var rerender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.renderer.setSize(width, height);
      this.updateCamera(width, height);

      // if not animating render should be called directly
      if (rerender && !this.isAnimating()) {
        this.render();
      }
    }

    /**
     * Creates a simple cube for testing the scene setup
     * @returns {Mesh}
     */
  }, {
    key: "createSampleCube",
    value: function createSampleCube() {
      var geometry = new _three.BoxGeometry(1, 1, 1);
      var material = new _three.MeshBasicMaterial({
        color: 0x00ff00
      });
      var cube = new _three.Mesh(geometry, material);
      return cube;
    }

    /**
     * Implement this function to add default lights to the scene
     */
  }, {
    key: "setupDefaultLightning",
    value: function setupDefaultLightning() {}

    /**
     * @param {HTMLElement} targetElement
     * @param {{}} options Custom options for the controls (see the OrbitControls.js file for details)
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "setupDefaultControls",
    value: function setupDefaultControls(targetElement) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    }
  }, {
    key: "addAxesHelper",
    value: function addAxesHelper() {
      var axesHelper = new _three.AxesHelper(50);
      this.scene.add(axesHelper);
    }

    /**
     * Enable or disable the controls
     * @param {boolean} [enabled=true]
     */
  }, {
    key: "setControlsEnabled",
    value: function setControlsEnabled() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.controls) {
        throw new Error("The controls should be available for the setControlsEnabled call!");
      }
      this.controls.enabled = enabled;
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "updateMaterial",
    value: function updateMaterial() {
      var targetObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scene;
    }

    /**
     * Getter function for the customizable materials
     * @returns {Array}
     */
  }, {
    key: "getCustomizableMaterials",
    value: function getCustomizableMaterials() {
      return this._customizableMaterials;
    }
  }, {
    key: "isCustomizableMaterialAvailable",
    value: function isCustomizableMaterialAvailable() {
      return this._customizableMaterials.length > 0;
    }

    /**
     * Returns the material for the given name, or false if not found.
     * @param {string} name
     * @returns {boolean|Material}
     */
  }, {
    key: "findMaterialByName",
    value: function findMaterialByName(name) {
      var _iterator = _createForOfIteratorHelper(this._customizableMaterials),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mat = _step.value;
          if (mat.name === name) {
            return mat;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }

    /**
     * Calls the given drawing function for custom drawing implementations
     * It provides the drawing context and the original texture image to the callback function.
     * It also invalidates the texture to make it update in the next render.
     * Calls the render function if it's not animating continuously.
     * @param {function(ctx: CanvasRenderingContext2D, image: HTMLImageElement)} drawingFn
     * @param {boolean} updateAlpha
     * @param {boolean} clearTexture
     * @param {string|undefined} materialName If not provided it uses the first customizable material
     */
  }, {
    key: "getDrawingContext",
    value: function getDrawingContext(drawingFn) {
      var updateAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var clearTexture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var materialName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      if (this._disableRender || !this._isInitialized) {
        return;
      }
      try {
        this.renderer && this.renderer.render(this.scene, this.camera);
      } catch (e) {
        console.error("Rendering failed with the following error:", e);
      }
    }
  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return this._isAnimating;
    }
  }, {
    key: "cleanUpCameraAnimations",
    value: function cleanUpCameraAnimations() {
      this.stopAnimation("camera");
      this.cameraTweenGroup.getAll().forEach(function (t) {
        return t.stop();
      });
      this.cameraTweenGroup.removeAll();
    }

    /**
     * Ads a click event listener to the targetElement
     * The hit test will be performed only if the controls are enabled.
     * On success it dispatches the EventTypes.Intersection event with the intersection data.
     * @see getIntersection
     * @see Observable
     * @see createPointerHitListener
     * @param targetElement
     */
  }, {
    key: "setupDefaultHitTest",
    value: function setupDefaultHitTest(targetElement) {
      var _this3 = this;
      var element = targetElement || this.renderer.domElement;
      (0, _pointerEvent.createPointerHitListener)(element, function (evt) {
        if (!_this3._hitTestEnabled) {
          return;
        }
        if (!_this3.controls || _this3.controls.enabled || _this3._cameraMovementLocked) {
          var is = _this3.getIntersection(evt);
          _this3.observable.dispatch(is ? _Constants.EventTypes.Intersection : _Constants.EventTypes.ClickAway, is);
        }
      });
      (0, _pointerEvent.createMouseMoveListener)(element, {
        onMove: function onMove(evt) {
          if (!_this3._hitTestEnabled) {
            return;
          }
          var is = _this3.getIntersection(evt);
          _this3.observable.dispatch(is ? _Constants.EventTypes.HoverIn : _Constants.EventTypes.HoverOut, is);
        },
        onLeave: function onLeave() {
          if (!_this3._hitTestEnabled) {
            return;
          }
          _this3.observable.dispatch(_Constants.EventTypes.HoverOut);
        }
      });
    }
  }, {
    key: "textureHitFormatter",
    value: function textureHitFormatter(intersect, position) {
      return position;
    }
  }, {
    key: "setupContextLostHandling",
    value: function setupContextLostHandling() {
      var _this = this;
      this.renderer.getContext().canvas.addEventListener("webglcontextlost", function (event) {
        event.preventDefault();
        window.cancelAnimationFrame(_this._animationFrame);
        // eslint-disable-next-line no-console
        console.warn("WEBGL CONTEXT LOST");
      }, false);
      this.renderer.getContext().canvas.addEventListener("webglcontextrestored", function () {
        // if it was animating before start it again
        if (_this._animationFrame) {
          _this.animate();
        }
        // eslint-disable-next-line no-console
        console.warn("WEGL CONTEXT RESTORED");
      }, false);
    }
  }, {
    key: "toggleCameraLock",
    value: function toggleCameraLock(locked) {
      this._cameraMovementLocked = locked;
      if (this.controls) {
        this.controls.enabled = !locked;
      }
    }
  }, {
    key: "toggleHitTest",
    value: function toggleHitTest(enabled) {
      this._hitTestEnabled = enabled;
    }
  }, {
    key: "clearScene",
    value: function clearScene() {
      // remove all Group objects
      this.scene.children.filter(function (obj) {
        return obj.type === "Group";
      }).forEach(_removeObject.removeObject);

      // clear customizable materials and camera views
      this._customizableMaterials = [];
      this.cameraViews = {};
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.stopAnimation();
      this.cleanUpCameraAnimations();
      this.observable.dispose();
      if (this._container && this.renderer) {
        this._container.removeChild(this.renderer.domElement);
      }
      if (this.scene) {
        this.scene.traverse(function (obj) {
          if (obj.geometry) {
            obj.geometry.dispose();
          }
          if (obj.material) {
            (0, _disposeMaterial.disposeMaterial)(obj.material);
          }
        });
      }
      this.scene = null;
      if (this.renderer) {
        this.renderer.dispose();
      }
      this.renderer = null;
      this.camera = null;
      this.cameraViews = null;
      this.controls = null;
      this._customizableMaterials = [];
      this._isInitialized = false;

      // eslint-disable-next-line no-console
      console.info("Three instance has been successfully disposed.");
    }
  }, {
    key: "abortScreenshotting",
    value: function abortScreenshotting() {
      this._screenshottingInProgress && Object.defineProperty(this, "_abortScreenshotting", {
        configurable: true,
        get: function get() {
          delete this._abortScreenshotting;
          return true;
        }
      });
    }
  }, {
    key: "createTempOverlay",
    value: function () {
      var _createTempOverlay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var canvas, _createWorkingCanvas, _createWorkingCanvas2, tmpCanvas, scale, container;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              canvas = this.renderer.domElement;
              this.render();
              _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)(canvas, true), _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 1), tmpCanvas = _createWorkingCanvas2[0];
              scale = 1 / this.renderer.getPixelRatio();
              container = this._container;
              Object.assign(tmpCanvas.style, {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) scale(".concat(scale, ", ").concat(scale, ")"),
                opacity: 0
              });
              container.insertBefore(tmpCanvas, canvas);
              _context2.next = 9;
              return new Promise(function (resolve) {
                window.requestAnimationFrame(function () {
                  tmpCanvas.style.opacity = 1;
                  canvas.style.visibility = "hidden";
                  resolve();
                });
              });
            case 9:
              return _context2.abrupt("return", function () {
                canvas.style.visibility = "visible";
                container.removeChild(tmpCanvas);
              });
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createTempOverlay() {
        return _createTempOverlay.apply(this, arguments);
      }
      return createTempOverlay;
    }()
  }]);
  return ThreeBase;
}(_VisualizationInterface.VisualizationInterface);